import React, { useEffect, useState } from 'react';
import {
  Button,
  Grid,
  Typography,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel
} from '@mui/material';
import { Box } from '@mui/system';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useForm, Controller } from 'react-hook-form';
import { HiOutlineArrowNarrowLeft, HiOutlineArrowNarrowRight } from 'react-icons/hi';
import Loader from '../../../Global/Loader';
import CustomInput from '../../../../components/CustomInput';
import CustomSelect from '../../../../components/CustomSelect';
import useLoginSelector from '../../../../store/Slice/Login/LoginSelector';
import useAgreementSelector from '../../../../store/Slice/Agreement/AgreementSelector';
import {
  getInvoiceModeList,
  updateAgreementBilling
} from '../../../../store/Slice/Agreement/AgreementSlice';

export default function AggrementAddStep6({
  handlePrev,
  setActiveStep,
  reviewData,
  setReviewData
}) {
  const [openLoader, setOpenLoader] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { LoginData } = useLoginSelector();
  const { InvoiceModeDrop } = useAgreementSelector();

  const {
    control,
    handleSubmit,
    watch,
    formState: { errors }
  } = useForm({
    defaultValues: {
      chargebackEnabled: false,
      chargebackPeriodDays: '',
      chargebackAmount: '',
      billingCycleDay: '',
      tdsPercent: '',
      gstPercent: '',
      invoiceMode: ''
    }
  });

  const chargebackEnabled = watch('chargebackEnabled');

  useEffect(() => {
    dispatch(getInvoiceModeList());
  }, []);

  const billingCycleOptions = Array.from({ length: 30 }, (_, i) => ({
    label: String(i + 1),
    value: i + 1
  }));

  const onSubmit = async (data) => {
    setOpenLoader(true);

    const localReviewData = JSON.parse(localStorage.getItem('agreementId')) || {};
    // const agreementId =
    //   localReviewData?.agreementId || localReviewData?.id || localReviewData?.data?.agreementId;

    const payload = {
      agreementId: localReviewData?.agreementId || ' ',
      chargebackEnabled: data.chargebackEnabled,
      chargebackPeriodDays: data.chargebackEnabled ? Number(data.chargebackPeriodDays) : ' ',
      chargebackAmount: data.chargebackEnabled ? Number(data.chargebackAmount) : ' ',
      billingCycleDay: Number(data.billingCycleDay),
      tdsPercent: Number(data.tdsPercent),
      gstPercent: Number(data.gstPercent),
      invoiceMode: data.invoiceMode,
      paymentTermsDays: 15,
      userId: Number(LoginData?.userId)
    };

    const res = await dispatch(updateAgreementBilling(payload));
    setOpenLoader(false);
    if (res) {
      setActiveStep((prev) => prev + 1);
      const updatedReviewData = { ...reviewData, billingDetails: payload };
      setReviewData(updatedReviewData);
      localStorage.setItem('reviewData', JSON.stringify(updatedReviewData));
    }
  };

  return (
    <Box mt={3} mb={3}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Typography variant="body1" className="headingLineUp headingLineUpOut">
          Billing Details
        </Typography>
        <Box className="viewLeadCard cardTopMinusMargin" p={3}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={4}>
              <FormControl component="fieldset">
                <FormLabel component="legend" className="formLabel">
                  Chargeback Enabled
                </FormLabel>
                <Controller
                  name="chargebackEnabled"
                  control={control}
                  render={({ field }) => (
                    <RadioGroup
                      row
                      {...field}
                      value={field.value.toString()}
                      onChange={(e) => field.onChange(e.target.value === 'true')}
                    >
                      <FormControlLabel value="true" control={<Radio size="small" />} label="Yes" />
                      <FormControlLabel value="false" control={<Radio size="small" />} label="No" />
                    </RadioGroup>
                  )}
                />
              </FormControl>
            </Grid>

            {chargebackEnabled && (
              <>
                <Grid item xs={12} md={4}>
                  <CustomInput
                    name="chargebackPeriodDays"
                    label="Chargeback Period (Days)"
                    type="number"
                    control={control}
                    errors={errors}
                    isRequired
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <CustomInput
                    name="chargebackAmount"
                    label="Chargeback Amount"
                    type="number"
                    control={control}
                    errors={errors}
                    isRequired
                  />
                </Grid>
              </>
            )}

            <Grid item xs={12} md={4}>
              <CustomSelect
                name="billingCycleDay"
                label="Billing Cycle Day"
                options={billingCycleOptions}
                control={control}
                errors={errors}
                isRequired
              />
            </Grid>

            <Grid item xs={12} md={4}>
              <CustomInput
                name="tdsPercent"
                label="TDS Percent (%)"
                type="number"
                control={control}
                errors={errors}
                isRequired
              />
            </Grid>

            <Grid item xs={12} md={4}>
              <CustomInput
                name="gstPercent"
                label="GST Percent (%)"
                type="number"
                control={control}
                errors={errors}
                isRequired
              />
            </Grid>

            <Grid item xs={12} md={4}>
              <CustomSelect
                name="invoiceMode"
                label="Invoice Mode"
                options={InvoiceModeDrop}
                control={control}
                errors={errors}
                isRequired
              />
            </Grid>
          </Grid>
        </Box>

        <Box sx={{ display: 'flex', paddingTop: '1.5rem' }}>
          <Button
            onClick={handlePrev}
            startIcon={<HiOutlineArrowNarrowLeft />}
            className="mainBtn previousBtn"
          >
            Back
          </Button>
          <Button type="submit" endIcon={<HiOutlineArrowNarrowRight />} className="mainBtn nextBtn">
            Next
          </Button>
        </Box>
      </form>
      <Loader openLoader={openLoader} />
    </Box>
  );
}
